import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { RadioWithLabel } from "./RadioWithLabel";
import { RadioContext } from "./context";
export const Radio = ({ checked, disabled, label, labelStyle, value, error, onChange, }) => {
    const { radioGroup } = useContext(RadioContext);
    const { disabled: contextDisabled, value: contextValue, onChange: contextOnChange, } = radioGroup;
    return (_jsx(RadioWithLabel, { disabled: disabled || contextDisabled, value: value || contextValue, label: label, labelStyle: labelStyle, error: error, onChange: onChange || contextOnChange, checked: checked || value === contextValue }));
};
